module.exports = __webpack_public_path__ + "static/img/12.d648418.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/12.png
// module id = +6ZF
// module chunks = 0